import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-564ef3da")

_pushScopeId("data-v-564ef3da")
const _hoisted_1 = { class: "signup-privacy-policy" }
const _hoisted_2 = { class: "signup-privacy-policy__content" }
const _hoisted_3 = { class: "agree" }
const _hoisted_4 = { class: "p-field-checkbox" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", {
  for: "agree1",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" 개인정보 수집 이용 동의 "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(필수)")
], -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<table class=\"-medium\" data-v-564ef3da><thead data-v-564ef3da><tr data-v-564ef3da><th data-v-564ef3da>목적</th><th data-v-564ef3da>항목</th><th data-v-564ef3da>보유기간</th></tr></thead><tbody data-v-564ef3da><tr data-v-564ef3da><td data-v-564ef3da><span data-v-564ef3da>이용자 식별 및 회원관리</span></td><td data-v-564ef3da><span data-v-564ef3da>이메일, 비밀번호, 이름, 휴대폰 번호, 성별</span></td><td data-v-564ef3da><span data-v-564ef3da>회원탈퇴 후 바로 삭제</span></td></tr></tbody></table>", 1)
const _hoisted_7 = { class: "agree" }
const _hoisted_8 = { class: "p-field-checkbox" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "agree2",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" 화상 상담 중 영상 활용 동의 "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(필수)")
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, " 원활한 처방을 위해 의사가 화상 상담 중 진단을 위해 필요한 병변, 상처 등 외관적 신체 이미지를 저장 할 수 있으며, 처방 이외의 목적으로는 활용되지 않음을 알려 드립니다. ", -1)
const _hoisted_12 = { class: "agree" }
const _hoisted_13 = { class: "p-field-checkbox" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  for: "agree3",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" 회원가입 유의사항 확인 및 동의 "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(필수)")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "ps" }, [
  /*#__PURE__*/_createVNode("span", null, "인적사항 허위 기재 또는 명의 도용에 관한 책임"),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("ol", null, [
      /*#__PURE__*/_createVNode("li", null, "1. 회원이 회원가입시 성명, 생년월일, 여권번호 등의 인적사항을 허위기재하거나 타인의 인적사항을 도용한 경우에는 관련 법령에 따라 형사처벌을 받을 수 있습니다."),
      /*#__PURE__*/_createVNode("li", null, "2. 회사와 의료기관은 회원이 제 1항과 같이 인적사항 허위기재 또는 타인 명의 도용을 통해 본 서비스를 이용할 경우에는 서비스 이용으로 인하여 발생한 회원의 손해를 배상할 책임이 없습니다."),
      /*#__PURE__*/_createVNode("li", null, "3. 만약 회원의 허위 기재 또는 명의 도용으로 인하여 회사 또는 의료기관과 손해가 발생한 경우 회원은 회사 및 의료기관에 대하여 손해배상책임을 부담합니다.")
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Checkbox, {
            id: "agree1",
            modelValue: _ctx.state.agree1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.agree1 = $event)),
            class: "-royalBlue check-box",
            binary: true
          }, null, 8, ["modelValue"]),
          _hoisted_5
        ]),
        _hoisted_6
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Checkbox, {
            id: "agree2",
            modelValue: _ctx.state.agree2,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.agree2 = $event)),
            binary: true,
            class: "-royalBlue check-box"
          }, null, 8, ["modelValue"]),
          _hoisted_9
        ]),
        _hoisted_10,
        _hoisted_11
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_Checkbox, {
            id: "agree3",
            modelValue: _ctx.state.agree3,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.agree3 = $event)),
            binary: true,
            class: "-royalBlue check-box"
          }, null, 8, ["modelValue"]),
          _hoisted_14
        ]),
        _hoisted_15,
        _hoisted_16
      ])
    ])
  ]))
})